module.exports = __webpack_public_path__ + "img/acc1.5d9f9870.png";